import * as React from "react";
import { LOBState } from "src/stores/wizard/state";
import {
  UitkLayoutConditionalGridSpan,
  UitkLayoutGridItem,
  UitkLayoutConditionalGridStartEnd,
} from "uitk-react-layout-grid";
import { UitkButtonSize, UitkPrimaryButton } from "uitk-react-button";
import { useLocalization } from "@shared-ui/localization-context";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { CobrandImage } from "components/shared/CobrandImage/CobrandImage";
import { GlobalConfig } from "stores/wizard/config";
import { CheckboxModuleNameTypes } from "src/components/shared/PropertyFIlterComponents/components/Checkbox";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { WizardClickstreamContext } from "components/flexComponents/PageLevelProviders/WizardContextProvider/WizardClickstreamContext";

import { clickstreamSchema } from "src/stores/wizard/config/staticConfigs/clickstream/clickstreamSchema";

const ButtonTracked = FlexClickTracker(UitkPrimaryButton);

export interface SubmitButtonProps {
  lobState: LOBState;
  colSpan?: UitkLayoutConditionalGridSpan;
  colStart?: UitkLayoutConditionalGridStartEnd;
  colEnd?: UitkLayoutConditionalGridStartEnd;
  className?: string;
  rfrr?: string;
  uisPrimeMicroMessages?: object[];
  globalConfig?: GlobalConfig;
  disabled?: boolean;
  moduleName?: string;
  testId?: string;
}

export const SubmitButton: React.FunctionComponent<SubmitButtonProps> = ({
  colSpan,
  colStart,
  colEnd,
  lobState,
  className,
  rfrr,
  uisPrimeMicroMessages,
  globalConfig,
  disabled,
  moduleName,
  testId = "submit-button",
}) => {
  const { formatText } = useLocalization();
  const moduleNameType = moduleName === CheckboxModuleNameTypes.WIZARD_HOTEL_V2_HTG ? moduleName : "StorefrontWizard";

  const track = useEgClickstream();
  const wizardClickstream = React.useContext(WizardClickstreamContext);

  const onClick = () => {
    if (wizardClickstream.isEnabled) {
      track(clickstreamSchema.searchSubmitted);
    }
  };

  return (
    <UitkLayoutGridItem colSpan={colSpan} colStart={colStart} colEnd={colEnd} className={className ?? ""}>
      <div>
        <ButtonTracked
          data-testid={testId}
          tag="button"
          type="submit"
          size={UitkButtonSize.LARGE}
          isFullWidth
          moduleName={moduleNameType}
          onClick={onClick}
          rfrr={rfrr || `SearchClick_NA`}
          uisPrimeMicroMessages={uisPrimeMicroMessages}
          disabled={disabled}
        >
          {formatText(lobState.config.form.submitButton.locToken)}
        </ButtonTracked>
        <CobrandImage globalConfig={globalConfig} />
      </div>
    </UitkLayoutGridItem>
  );
};
